/** API route map: URLS.Controller.EmployeeTypes */
export const EmployeeTypes = {
      Name: 'EmployeeType/',
      GetEmployeeTypesPaginated: 'get-employee-types-paginated',
      GetEmployeeTypes: 'get-employee-types',
      AddEmployeeType: 'add-employee-type',
      UpdateEmployeeType: 'update-employee-type',
      DeleteEmployeeType: 'delete-employee-type',
      UpdateStatus: 'update-status',
};
